import { getFirstWeekWeightLoss } from "../helpers"

export default (getView) =>
  ({ nextStepPath, formFields }) => ({
    ...getView({
      nextStepPath,
      formFields,
    }),

    init() {
      this.store = Alpine.store("data")
      this.commonInit()
      this.store.values.marketingAgreed = false
    },

    getFirstWeekWeightLoss() {
      return getFirstWeekWeightLoss(this.store.values)
    },

    handleSubmit() {
      if (isEmailStored()) {
        window.analytics.track(window.getEventName("Continue Clicked"))
      }

      this.store.values.marketingAgreed = true
      this.submit({ push: true, withToken: true })
    },
  })
